// extracted by mini-css-extract-plugin
export default {"filter_icon":"SearchFilterIcon_filter_icon__fGn7p","filter_wrapper":"SearchFilterIcon_filter_wrapper__XvtOj","filter_Text":"SearchFilterIcon_filter_Text__WODpY"};